@if (type !== 'time') {
  <mat-form-field class="date-picker-custom"
                  floatLabel="always">
    <mat-label>{{ title! | translate }}</mat-label>
    <input #inputControl="ngModel"
           [disabled]="disabled"
           [ngModel]="value"
           [required]="required"
           [value]="value"
           matInput>
    <persian-date-picker
      (blur)="onTouched()"
      (ngModelChange)="onChangeDate($event)"
      [(ngModel)]="value"
      [allowEmpty]="allowEmpty"
      [calendarType]="calendarType"
      [disabled]="disabled"
      [footerDescription]="footerDescription"
      [format]="visibleTimePicker ? format! : 'yyyy-MM-dd'"
      [isRange]="isRange"
      [maxDate]="maxDate!"
      [minDate]="minDate!"
      [mode]="mode"
      [rangeInputLabels]="rangeInputLabel!"
      [required]="required"
      [rtl]="rtl"
      [showSidebar]="showSidebar"
      [showToday]="showToday"
      [valueFormat]="visibleTimePicker ? valueFormat : 'gregorian'"
    ></persian-date-picker>
    <mat-datepicker-toggle matSuffix></mat-datepicker-toggle>
    <mat-error *ngIf="inputControl?.errors?.['required']">{{ 'این فیلد اجباری است' }}
    </mat-error>
  </mat-form-field>
} @else {
  <mat-form-field class="date-picker-custom"
                  floatLabel="always">
    <mat-label>{{ title! | translate }}</mat-label>
    <input #inputControl="ngModel"
           [disabled]="disabled"
           [ngModel]="value"
           [required]="required"
           [value]="value"
           matInput>
    <persian-time-picker
      (blur)="onTouched()"
      (ngModelChange)="onChangeDate($event)"
      [(ngModel)]="value"
      [disabled]="disabled"
      [displayFormat]="timeDisplayFormat"
      [inline]="isInline"
      [maxTime]="maxTime"
      [minTime]="minTime"
      [required]="required"
      [rtl]="rtl"
      [showIcon]="showIcon"
      [valueType]="timeValueType"
    ></persian-time-picker>
    <mat-error *ngIf="inputControl?.errors?.['required']">{{ 'این فیلد اجباری است' }}
    </mat-error>
  </mat-form-field>
}
